// Settings：全局变量的配置  PcLockr：优雅的本地存储  PcEncrypt：前端加密
import {PcLockr} from 'util/'
const state = {
    loginName: '',
    userInfo: null,
    token: '',
    hostCode: ''
}

const getters = {
    getLoginName: (state) => {
        if (PcLockr.get('userInfo')) {
            return state.loginName || PcLockr.get('userInfo').truename
        }
        return ''
    },
    getUserInfo: (state) => {
        return state.userInfo || PcLockr.get('userInfo')
    },
    getToken: (state) => {
        return state.token || PcLockr.get('token')
    },
    getHostCode: (state) => {
        return state.hostCode || PcLockr.get('hostCode')
    }
}

const mutations = {
    setToken(state, data) {
        PcLockr.set('token', data)
    },
    setHostCode(state, data) {
        PcLockr.set('hostCode', data)
    },
    setUserInfo(state, data) {
        PcLockr.set('userInfo', data)
        state.userInfo = data
    },
    clearLoginMsg(state) {
        PcLockr.set('token', '')
        PcLockr.set('userInfo', null)
        state.loginName = ''
        state.userInfo = null
        state.token = ''
    }
}

const actions = {
    getUserInfo({commit}, data) {
        commit('getUserInfo', data)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/user/index.js